import { useAuthenticatedFetch } from "../../../lib/api";
import { deserializeExplanationPercents } from "../../percents";
import type { ExplainResponseV3 } from "../lib/explainTypes";

// Architecture spec §7.1 + phase 5: this hook is the single
// integration point with the v3 endpoint. Cutover (job 8) flips the
// page from legacy `/explain` to here without touching individual
// component code.
//
// The v3 endpoint is `GET /v1/rebalances/:id/explain` (APP-1652: renamed
// from `/rebalances/:id/explain/v3`, served at `/v1` only). The unversioned
// `/rebalances/:id/explain` is the legacy handler.
//
// The endpoint sends the weights on 0 to 100 (APP-1652); `select` gives the
// tree the worker's 0 to 1 text it always read (`deserializeExplanationPercents`,
// `../../percents`). The admin viewer and the manual rebalance pass their
// 0 to 1 payload as the tree's `response` prop and never reach this hook.

interface ApiResponse<T> {
  data: T;
}

type ExplainBody = ApiResponse<ExplainResponseV3 | null>;

/** The body with its explanation on 0 to 1. */
function selectExplanationRatios(body: ExplainBody): ExplainBody {
  return body.data === null
    ? body
    : { ...body, data: deserializeExplanationPercents(body.data) };
}

export function useExplain(rebalanceId: number | undefined) {
  return useAuthenticatedFetch<ExplainBody>(
    `/v1/rebalances/${rebalanceId}/explain`,
    {},
    {
      staleTime: 60_000,
      enabled: rebalanceId != null,
      select: selectExplanationRatios,
    },
    [`/v1/rebalances/${rebalanceId}/explain`],
  );
}
